import React from "react";
import "../styles/autocomplete.css";
import Select from "react-select";
const Autocomplete = (props) => {
  //
  const onChange = (e) => {
    let newform = JSON.parse(JSON.stringify(props.state));
    if (props.atribute) {
      newform[0][props.atribute][props.i][props.name] = e.value;

      props.setState(newform);

      if (props.formularioUpdate) {
        let newform2 = JSON.parse(JSON.stringify(props.formularioUpdate));
        newform2[props.name] = e.value;

        props.setformularioUpdate(newform2);
      }
    } else {
      newform[props.i][props.name] = e.value;

      props.setState(newform);

      if (props.formularioUpdate) {
        let newform2 = JSON.parse(JSON.stringify(props.formularioUpdate));
        newform2[props.name] = e.value;

        props.setformularioUpdate(newform2);
      }
    }
  };

  return (
    <>
      <Select
        onChange={onChange}
        options={props.suggestions}
        value={props.suggestions.filter(
          (option) => option.value === props.value
        )}
      />
    </>
  );
};
export default Autocomplete;
